import React, { forwardRef, ReactElement, useCallback } from "react";

import { bemClassNames, createQA } from "@multiweb/reactUtils";
import { ForwardRefType } from "@multiweb/types/react";
import { ComponentTheme } from "@multiweb/uiShared/ComponentTheme";
import { DropdownItemBaseProps } from "../../types";

const classNames = bemClassNames("dropdown-item-wrapper");

export type DropdownItemWrapperProps = {
    /** Tělo tlačítka */
    children: ReactElement;
} & DropdownItemBaseProps;

export const DropdownItemWrapper: ForwardRefType<HTMLDivElement, DropdownItemWrapperProps> = forwardRef<HTMLDivElement, DropdownItemWrapperProps>(({
    clickAction,
    qa,
    theme = ComponentTheme.default,
    children,
}, ref) => {
    const clickEvent = useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        clickAction?.onClick?.(e, "main");
    }, [ clickAction ]);

    return (
        <div
            className={classNames({ disabled: clickAction?.disabled }, [`theme-${theme}`])}
            aria-label={clickAction?.title}
            aria-disabled={clickAction?.disabled ?? false}
            role="button"
            tabIndex={0}
            onClick={clickEvent}
            title={clickAction?.title}
            {...{ ref }}
            {...createQA(qa)}
        >
            {children}
        </div>
    );
});
